export function getFormattedDuration(valueInSeconds) {
    if (!valueInSeconds) {
        valueInSeconds = 0;
    }

    const pad = (v) => String(v).padStart(2, '0');

    const hour = Math.floor(valueInSeconds / 3600);

    valueInSeconds %= 3600;
    const minutes = pad(Math.floor(valueInSeconds / 60));

    valueInSeconds %= 60;
    const seconds = pad(Math.floor(valueInSeconds));

    if (hour === 0) {
        return `${minutes}:${seconds}`;
    }

    return `${hour}:${minutes}:${seconds}`;
}
